import { apiErrorHandler, oktaAxios as axios } from "@/vue/api/config";
import { smartyToValidationDto } from "@/vue/utils/trunkGateways";
import defaultState from "@/vue/utils/defaultState";

const defState = defaultState("addresses", {
  addresses: {},
});

export const addresses = {
  state: defState.state,
  getters: {
    getAddresses: (state) => Object.values(state.addresses),
    getAddress: (state) => (id) => state.addresses[id],
  },
  mutations: {
    ...defState.mutations,
    ADD_ADDRESS(state, { address }) {
      state.addresses = {
        ...state.addresses,
        [address.id]: address,
      };
    },
    REMOVE_ADDRESS(state, { id }) {
      if (state.addresses[id]) {
        delete state.addresses[id];
      }
    },
  },
  actions: {
    async fetchAddress({ commit, getters }, { addressId, customerId }) {
      const response = await axios
        .get(`/v1/address-management/customers/${customerId}/${addressId}`)
        .catch(apiErrorHandler);
      const address = response.data;
      commit("ADD_ADDRESS", { address });
    },
    async maybeFetchAddresses(
      { commit, getters, dispatch },
      { customerId, addresses }
    ) {
      Object.keys(addresses).forEach((addressId) => {
        if (getters.getAddress[addressId]) {
          return;
        }
        dispatch("fetchAddress", { addressId, customerId });
      });
    },
    async validateAddress({ commit, getters }, { country, freeForm }) {
      let smartyResponse = null;

      smartyResponse = await axios
        .post(`/v1/address-management/validate`, {
          country,
          freeForm,
        })
        .catch((e) => {
          console.error(e);
          if (e.response && e.response.data) {
            const validation = e.response.data;
            const message = !validation.failed
              ? validation.message
              : validation.failed[0].resultPayload.description;
            throw new Error(message);
          }
          throw e;
        });

      const validateAddressDto = smartyToValidationDto(smartyResponse);

      const response = await axios
        .post(`/v1/address-management/validate/full`, validateAddressDto)
        .catch(apiErrorHandler);

      if (!response.data || !response.data.length) {
        throw new Error(
          `No validated addresses returned: ${JSON.stringify(response.data)}`
        );
      }

      return response.data[0].address;
    },
    async createAddress({ commit }, { customerId, address }) {
      const response = await axios
        .post(`/v1/address-management/customers/${customerId}`, address)
        .catch(apiErrorHandler);
      address = response.data;
      commit("ADD_ADDRESS", { address });
      return address;
    },
    async searchAddress({ commit }, { customerId, address }) {
      const response = await axios
        .post(`/v1/address-management/customers/${customerId}/search`, address)
        .catch(apiErrorHandler);
      address = {
        ...address,
        ...response.data,
      };
      // if the address has no id means there's not been one found
      if (!address.id) {
        return null;
      }
      commit("ADD_ADDRESS", { address });
      return address;
    },
    async deleteAddress({ commit }, { customerId, address }) {
      await axios
        .delete(`/v1/address-management/customers/${customerId}/${address.id}`)
        .catch(apiErrorHandler);
      commit("REMOVE_ADDRESS", { id: address.id });
    },
  },
};
